<template>
  <div class="ed-skeleton">
    <div class="ed-skeleton-container">
      <div class="ed-skeleton-layout">
        <!-- Sidebar Card -->
        <div class="ed-skeleton-sidebar">
          <div class="ed-sidebar-card">
            <!-- Cover Image -->
            <div class="ed-sidebar-image">
              <div class="skeleton-shimmer" style="width: 100%; height: 100%;"></div>
            </div>
            <!-- Card Body -->
            <div class="ed-sidebar-body">
              <!-- Progress -->
              <div class="ed-progress-section">
                <div class="ed-progress-header">
                  <span class="skeleton-shimmer" style="width: 100px; height: 13px;"></span>
                </div>
                <div class="ed-progress-bar">
                  <div class="skeleton-shimmer" style="width: 100%; height: 100%; border-radius: 4px;"></div>
                </div>
              </div>
              <!-- Buttons -->
              <div class="ed-actions">
                <div class="skeleton-shimmer ed-skeleton-btn ed-skeleton-btn--primary"></div>
                <div class="skeleton-shimmer ed-skeleton-btn ed-skeleton-btn--outline"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Content -->
        <div class="ed-skeleton-main">
          <!-- Hero Card -->
          <div class="ed-skeleton-hero">
            <div class="skeleton-shimmer" style="width: 90px; height: 24px; border-radius: 20px; margin-bottom: 12px;"></div>
            <div class="skeleton-shimmer" style="width: 75%; height: 22px; border-radius: 5px; margin-bottom: 10px;"></div>
            <div class="skeleton-shimmer" style="width: 160px; height: 14px; border-radius: 4px;"></div>
          </div>

          <!-- Tab Nav Skeleton -->
          <div class="ed-skeleton-tab-wrapper">
            <div class="ed-skeleton-tab-nav">
              <div class="skeleton-shimmer ed-skeleton-tab"></div>
              <div class="skeleton-shimmer ed-skeleton-tab"></div>
            </div>

            <!-- Tab Content -->
            <div class="ed-skeleton-tab-content">
              <!-- About title -->
              <div class="skeleton-shimmer" style="width: 140px; height: 18px; border-radius: 5px; margin-bottom: 12px;"></div>
              <div class="skeleton-shimmer" style="width: 100%; height: 2px; margin-bottom: 16px;"></div>
              <!-- Description lines -->
              <div class="skeleton-shimmer" style="width: 100%; height: 14px; margin-bottom: 8px;"></div>
              <div class="skeleton-shimmer" style="width: 90%; height: 14px; margin-bottom: 8px;"></div>
              <div class="skeleton-shimmer" style="width: 75%; height: 14px; margin-bottom: 24px;"></div>
              <!-- Hashtags -->
              <div style="display: flex; gap: 8px; margin-bottom: 24px;">
                <span class="skeleton-shimmer" style="width: 64px; height: 28px; border-radius: 6px;"></span>
                <span class="skeleton-shimmer" style="width: 80px; height: 28px; border-radius: 6px;"></span>
                <span class="skeleton-shimmer" style="width: 56px; height: 28px; border-radius: 6px;"></span>
              </div>
              <!-- Accordion items -->
              <div class="ed-skeleton-accordion">
                <div v-for="i in 3" :key="'section_' + i" class="ed-skeleton-accordion-item">
                  <div class="ed-skeleton-accordion-title">
                    <div class="skeleton-shimmer" style="width: 50%; max-width: 200px; height: 16px;"></div>
                  </div>
                  <template v-if="i === 1">
                    <div class="ed-skeleton-accordion-content">
                      <div v-for="j in 3" :key="'content_' + j" class="ed-skeleton-list-item">
                        <div class="skeleton-shimmer" style="width: 60px; height: 20px; border-radius: 16px;"></div>
                        <div class="skeleton-shimmer" style="flex: 1; max-width: 220px; height: 14px;"></div>
                        <div style="margin-left: auto; display: flex; align-items: center; gap: 6px;">
                          <div class="skeleton-shimmer" style="width: 14px; height: 14px; border-radius: 50%;"></div>
                          <div class="skeleton-shimmer" style="width: 45px; height: 13px;"></div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EducationDetailsSkeleton"
}
</script>

<style scoped>
@keyframes skeleton-shimmer-anim {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-shimmer {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eee 25%, #e5e5e5 50%, #eee 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer-anim 1.5s infinite;
}

/* Container — matches .ed-container */
.ed-skeleton-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 20px;
}

/* Layout — matches .ed-layout */
.ed-skeleton-layout {
  display: flex;
  gap: 32px;
}

/* Sidebar — 1/3 width, first */
.ed-skeleton-sidebar {
  width: 33.333%;
  min-width: 0;
  flex-shrink: 0;
  order: -1;
}

/* Main — 2/3 width */
.ed-skeleton-main {
  flex: 1;
  min-width: 0;
}

.ed-skeleton-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
}

.ed-skeleton-btn--primary {
  background: linear-gradient(90deg, #f5c6c6 25%, #f8d4d4 50%, #f5c6c6 75%) !important;
  background-size: 200% 100% !important;
  animation: skeleton-shimmer-anim 1.5s infinite !important;
}

.ed-skeleton-btn--outline {
  background: linear-gradient(90deg, #d1dff5 25%, #dce6f8 50%, #d1dff5 75%) !important;
  background-size: 200% 100% !important;
  animation: skeleton-shimmer-anim 1.5s infinite !important;
}

/* Hero card */
.ed-skeleton-hero {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 28px;
  margin-bottom: 20px;
}

/* Tab wrapper */
.ed-skeleton-tab-wrapper {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.ed-skeleton-tab-nav {
  display: flex;
  gap: 6px;
  padding: 16px 24px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.ed-skeleton-tab {
  width: 120px;
  height: 36px;
  border-radius: 8px 8px 0 0;
}

.ed-skeleton-tab-content {
  padding: 24px;
}

/* Accordion */
.ed-skeleton-accordion {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ed-skeleton-accordion-item {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.ed-skeleton-accordion-title {
  padding: 14px 16px;
  background: #f8fafc;
}

.ed-skeleton-accordion-content {
  display: flex;
  flex-direction: column;
}

.ed-skeleton-list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
}

/* ── Mobile (768px) — matches real page breakpoint ── */
@media (max-width: 768px) {
  .ed-skeleton-container {
    padding: 16px 12px;
  }

  .ed-skeleton-layout {
    flex-direction: column;
    gap: 16px;
  }

  .ed-skeleton-sidebar {
    width: 100%;
    order: -1;
  }

  .ed-skeleton-btn {
    flex: 1 1 auto;
    min-width: 0;
  }

  .ed-skeleton-hero {
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 14px;
  }

  .ed-skeleton-tab-wrapper {
    border-radius: 10px;
  }

  /* Tab: icon-only size */
  .ed-skeleton-tab-nav {
    padding: 10px 14px;
    gap: 4px;
  }

  .ed-skeleton-tab {
    width: 40px;
    height: 32px;
    border-radius: 6px 6px 0 0;
  }

  .ed-skeleton-tab-content {
    padding: 16px;
  }
}

/* ── Small mobile (480px) ── */
@media (max-width: 480px) {
  .ed-skeleton-container {
    padding: 12px 8px;
  }

  .ed-skeleton-hero {
    padding: 16px;
  }

  .ed-skeleton-tab-nav {
    padding: 8px 10px;
  }

  .ed-skeleton-tab {
    width: 36px;
    height: 30px;
  }

  .ed-skeleton-tab-content {
    padding: 12px;
  }

  .ed-skeleton-list-item {
    padding: 10px 12px;
    gap: 8px;
  }
}
</style>
